
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]/collection/[menuSectionId]",
      function () {
        return require("private-next-pages/dispensary/[cName]/collection/[menuSectionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]/collection/[menuSectionId]"])
      });
    }
  